module.exports = __webpack_public_path__ + "img/dl_dot.8a5e2de4.png";